import {
  Supertype,
  supertypeClass,
  property,
  remote,
  Remoteable,
  Persistable,
  amorphicStatic,
} from '@haventech/amorphic';
import {
  IsomorphicPersistent,
  Persistent,
  IsomorphicQuery,
  Query,
  Isomorphic,
  Serializable,
  AppController,
  SubController,
  Everything,
} from '@hit/amorphic-types';
import { FollowUp } from './FollowUp';
import { PolicyDoc } from './PolicyDoc';
import { FollowUpComment } from './FollowUpComment';
import { Utils } from '../Utils';

@supertypeClass({ toClient: true })
export class FollowUpQA extends Everything {
  @property({ getType: () => FollowUp })
  followUp: FollowUp;

  @property()
  uwQuestion: string;

  @property()
  question: string;

  @property()
  metadataKey: string;

  @property()
  answer: string;

  @property()
  answerDate: Date;

  @property({ type: Array, getType: () => PolicyDoc })
  documents: Array<PolicyDoc> = [];

  @property({ type: Array, getType: () => FollowUpComment })
  comments: Array<FollowUpComment> = [];

  @property()
  section: string;

  @property()
  displayOrder: number;

  error: string;

  constructor() {
    super();
  }

  static new(followUp, uwQuestionText?) {
    return new FollowUpQA().init(followUp, uwQuestionText);
  }

  init(followUp, uwQuestionText) {
    this.followUp = followUp;
    this.uwQuestion = uwQuestionText;
    return this;
  }

  modifyQuestionText(questionText) {
    this.question = questionText;
  }

  addComment(commentText, creator) {
    this.comments.push(FollowUpComment.new(this, commentText, creator));
  }

  linkToQuestionRef(metadataKey, section?) {
    this.metadataKey = metadataKey;
    this.section = section;
  }

  setAnswer(answer) {
    if (typeof answer === 'string') {
      this.answer = answer;
    }

    this.answerDate = Utils.now();
  }
}
